import {AppSettings} from '../constants';
import Jwt from '../helper/interceptors';
import { ObjToParam, MapResponse } from '../helper/helper-api';
import removeDiacritics from '../helper/remove-diacritics';
import { v4 as uuidv4 } from 'uuid';
import S3 from 'aws-sdk/clients/s3';
import { config, Credentials } from 'aws-sdk/lib/core';

export const addRegion = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI).post('/api/regions', params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const addMarket = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI).post('/api/markets', params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const editRegion = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI).put('/api/regions', params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const editMarket = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI).put('/api/markets', params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const searchRegion = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI).get(`/api/region/search?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getRegionById = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI).get(`/api/regions/${params}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getMarketById = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI).get(`/api/markets/${params}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getListRegion = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false).get('/select-lists/regions', params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getReportRegionList = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false).get(`/api/reports/region-select-list?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getListMarket = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false).get('/select-lists/markets', params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getReportMarketList = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false).get(`/api/reports/market-select-list?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getListMarketByRegion = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false).get(`/select-lists/markets?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const setupRegionPoAWS = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false).post('/api/aws/s3/credentials', params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const uploadRegionPoToS3 = (params, callback) => {
  config.credentials = new Credentials({
    accessKeyId: params.config.accessKeyId,
    secretAccessKey: params.config.secretAccessKey,
    sessionToken: params.config.sessionToken
  });

  const fileName = removeDiacritics(params.file.name);
  const enFileName = uuidv4() + '.' + fileName.split('.').pop();
  const s3 = new S3({ region: params.config.region });

  const payload = {
    ACL: 'public-read',
    Body: params.file,
    Bucket: params.config.bucket,
    ContentType: params.file.type,
    ContentDisposition: 'inline; filename="' + fileName + '"',
    Key: `${params.config.path}/${enFileName}`
  };
  let upload = s3.upload(payload);
  let isDelete = false;
  upload.send((error, data) => {
    if (data) {
      /**
       * callback delete file after upload file success
       */
      if (isDelete) {
        const bucketInstance = new S3({ region: params.config.region });
        bucketInstance.deleteObject({
          Bucket: params.config.bucket,
          Key: `${params.config.path}/${enFileName}`}, (err, res) => {
          if (res) {
            if (process.env.NODE_ENV === 'development') {
              console.log('File deleted successfully');
            }
          }
          else {
            if (process.env.NODE_ENV === 'development') {
              console.log('Check if you have sufficient permissions : ' + err);
            }
          }});
      } else {
        callback(true, {data, regionId: params.regionId});
      }
    }
    /**
     * callback when upload file success
     */
    else {
      callback(false, {data, regionId: params.regionId});
    }
  });
  /**
   * callback when user cancel uploading file
   */
  const cancelUpload = () => {
    setTimeout(upload.abort.bind(upload), 100);
  };
  const deleteFile = () => {
    isDelete = true;
  };
  if (params.file.size > 1024 * 1024 * 5) {
    callback('pending', {cancelUpload, uploadId: params.file.uploadId, fileName});
  } else {
    callback('delete', {deleteFile, uploadId: params.file.uploadId, fileName});
  }
};

export const uploadRegionPoToServer = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false).post(`/api/regions/${params.regionId}/documents`, params.data)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getRegionPo = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI).get(`/api/regions/${params.regionId}/documents`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const downloadRegionPo = (params) => {
  config.credentials = new Credentials({
    accessKeyId: params.config.accessKeyId,
    secretAccessKey: params.config.secretAccessKey,
    sessionToken: params.config.sessionToken
  });

  const bucketInstance = new S3({ region: params.config.region });
  bucketInstance.getObject({
    Bucket: params.config.bucket,
    Key: params.key}, (err, res) => {
    if (res) {
      var blob = new Blob([res.Body], {type: res.ContentType });
      var filename = params.fileName;
      if (typeof window.navigator.msSaveBlob !== 'undefined') {
        // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
        window.navigator.msSaveBlob(blob, filename);
      } else {
        var URL = window.URL || window.webkitURL;
        var downloadUrl = URL.createObjectURL(blob);

        if (filename) {
          // use HTML5 a[download] attribute to specify filename
          var a = document.createElement('a');
          // safari doesn't support this yet
          if (typeof a.download === 'undefined') {
            window.location = downloadUrl;
          } else {
            a.href = downloadUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
          }
        } else {
          window.location = downloadUrl;
        }

        setTimeout(() => { URL.revokeObjectURL(downloadUrl); }, 100); // cleanup
      }
    }
    else {
      console.log('Check if you have sufficient permissions : ' + err);
    }});
};

export const removeRegionPo = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI).delete(`/api/regions/${params.id}/documents/${params.docId}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};




// WEBPACK FOOTER //
// ./src/Region-Market/api.js